"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rolEchainModel = exports.rolEchainConfigWithAdapterLinkMock = void 0;
const echain_shared_articles_oo_1 = require("@igus/echain-shared-articles-oo");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
exports.rolEchainConfigWithAdapterLinkMock = {
    AEs: [],
    AverageEnvironmentTemperatur: { Value: 20, Unit: '°C' },
    ChildRelation: undefined,
    Children: [],
    DomainVersion: '',
    Espool: undefined,
    FileRefs: [],
    Fuehrungsrinnen: [],
    IAs: [],
    IaArrangement: echain_shared_igus_fundamentals_1.IaArrangement.single,
    IgusGUIds: [],
    IsAlienConfiguration: false,
    IsIgnoreSafetyDistance: false,
    IsStackingOfLeitungenAllowed: false,
    Kette: (0, echain_shared_ts_utils_1.clonePrimitive)(echain_shared_articles_1.rolEchainWithAdapterLink2828RMock),
    Konfektionierungen: [],
    LeitungBomBehavior: echain_shared_articles_oo_1.LeitungBomBehavior.UseAll,
    Leitungen: [],
    MontBes: [],
    MontageSets: [],
    PdfRefs: [],
    QuoteCount: 1,
    SplitPositionX: undefined,
    UseSameIAColorAndMaterial: false,
    Verpackungen: [],
    Zugentlastungen: [],
};
exports.rolEchainModel = {
    AEs: [
        {
            ArticleType: 'ae',
            EntityId: '01c5da28-5587-4c67-9de3-1ac6e6497783',
            ZubehoerRef: [],
            Id: 91356,
            ArtNr: {
                DE: '2605.34PZB.A2',
                US: '2605-34PZB-A2',
            },
            Bezeichnung: {
                'bg-BG': 'Mounting bracket, full set, Plastic, pivoting, with tiewrap plates',
                'pt-BR': 'Terminal de fixação, conjunto completo, Plástico, giratório, com placas de braçadeiras de cabos',
                'zh-CN': '接头，套件, 塑料，摆动，带扎带板',
                'cs-CZ': 'Koncovka, kompletní sada, Plast, otočný, s hřebenovými omezovači tahu',
                'de-DE': 'Anschlusselement, Komplettsatz, Kunststoff, pendelnd, mit Kämme',
                'da-DK': 'Monteringsbeslag, fuldt sæt, Plast, drejeligt, med kabelkanaler',
                'es-ES': 'Juego completo de terminales montados (A2), oscilantes, con peines',
                'fr-FR': 'Eléments de fixation, jeu complet, Polymère, oscillant, avec peignes serre-câbles',
                'en-GB': 'Mounting bracket, complete set, plastic, pivoting, with tiewrap plates',
                'hu-HU': 'Szerelőkonzol, teljes készlet, Műanyag, elforduló, kábelbilincses lemezekkel',
                'it-IT': 'Attacco, set completo, Plastica, attacco oscillante, con pettini fissacavi',
                'ja-JP': '取付ブラケット、両端セット, 樹脂製、旋回型、くし歯型ケーブルクランプ付き',
                'ko-KR': '마운팅 브라켓, 풀 세트, 플라스틱, 피봇형, 타이랩 플레이트 포함',
                'nl-NL': 'Aansluitelementenset, volledige set, Plastic, scharnierend, met tiewrap-plaat',
                'no-NO': 'Mounting bracket, full set, Plastic, pivoting, with tiewrap plates',
                'pl-PL': 'Element mocujący, pełny zestaw, Polimerowy, wahliwy, z grzebieniami odciążającymi',
                'pt-PT': 'Terminal de fixação, conjunto completo, Plástico, oscilante, com pentes',
                'ru-RU': 'Монтажный кронштейн, полный набор, Полимер, поворотный, со стяжными пластинами',
                'sv-SE': 'Monteringsfäste, komplett sats, Plast, pendlande, med kammar',
                'zh-TW': '接頭，套件, 塑膠，擺動，帶紮帶板',
                'en-US': 'Mounting bracket, full set, Plastic, pivoting, with tiewrap plates',
            },
            Laenge: {
                Value: 176,
                Unit: 'mm',
            },
            AufbauId: 12,
            ZugentlastungTyp: 'Mit_Kamm',
            KomplettsatzUngerade: true,
            KomplettsatzGerade: true,
            MitnehmerUngerade: false,
            MitnehmerGerade: false,
            FestpunktUngerade: false,
            FestpunktGerade: false,
            Zweiteilig: false,
            Montiert: true,
            Befestigungsvariante: 'A2',
            KetteRef: [
                2980, 2981, 2982, 2983, 2984, 2985, 2986, 2987, 3172, 3173, 3174, 3175, 3176, 3177, 3178, 3179, 3299, 3300,
                3301, 3302, 3303, 3304, 3305, 3306, 4440, 4441, 4442, 4443, 4444, 4445, 4446, 4447, 4587, 4588, 4589, 4590,
                4591, 4592, 4666, 4667, 4668, 4669, 4670, 4671, 4672, 4673, 36762, 36763, 36764, 36765, 36766, 36767, 50226,
                50234, 51668, 51669, 51670, 51671, 51672, 51673, 51674, 51675, 51732, 51733, 51734, 51735, 51736, 51737, 51738,
                51788, 51789, 51790, 51791, 51792, 51793, 51794, 51844, 51845, 51846, 51847, 51848, 51849, 51850, 51851, 59577,
                68051, 82292, 82299, 82306, 82313, 82320, 82327, 82334, 82341, 82348, 82356, 82364, 82372, 82380, 82388, 82396,
                82404,
            ],
            Gewicht: {
                Value: 0.118549999237061,
                Unit: 'kg',
            },
            WidenBildId: '4cac18bf-f455-4f09-aec4-c05266925e2e',
            WidenZeichnungId: {
                'de-DE': '5977bc7f-7571-4627-83dc-db809e6ea2a8',
            },
            Typ: 'kunststoff',
            Variante: 'mit_kaemme',
            Ausrichtung: 'pendelnd',
            Einbauart: ['F', 'G'],
            Werkstoff: 'igumid_G',
            Standard: true,
            ProAndCons: {
                'zh-CN': ['活动式', '用于短和长行程', '适合狭小的装配尺寸', '耐腐蚀', '用于锁定连接件', '无支持悬浮/垂直'],
                'cs-CZ': [
                    'Otočný        Pro krátké i dlouhé pojezdy.        Pro zúžené montážní proporce        odolný proti korozi        Pro pojistná spojení        zavěšený/vertikální bez podpory',
                ],
                'de-DE': [
                    'Pendelnd',
                    'Für kurze und lange Verfahrwege',
                    'Für enge Einbauverhältnisse',
                    'Korrosionsbeständig',
                    'Für starre Verbindungen',
                    'Hängend/stehend ohne Abstützung',
                ],
                'da-DK': [
                    'vippende',
                    'Til korte og lange vandringer',
                    'Til samlinger der skal være smalle',
                    'Korrosionsresistent',
                    'Til låsning af sammenkoblinger',
                    'Ophængt/lodret uden understøttelse',
                ],
                'es-ES': [
                    'oscilante',
                    'Para carreras cortas y largas',
                    'Para espacios reducidos',
                    'Resistente a la corrosión',
                    'Para extremos rígidos',
                    'Montaje suspendido/vertical sin soporte',
                ],
                'fr-FR': [
                    'pendulaire',
                    'Pour les courses courtes et longues',
                    'Pour les petits espaces',
                    'Résistant à la corrosion',
                    'Pour liaisons rigides',
                    'Suspendu/vertical sans support',
                ],
                'en-GB': [
                    'Pivoting',
                    'For short and long travels',
                    'For tight installation spaces',
                    'Corrosion-free',
                    'Locking connections',
                    'Hanging/standing without support',
                ],
                'hu-HU': [
                    'billenő',
                    'Rövid és hosszú pályákhoz',
                    'Keskeny összeszerelési méretekhez',
                    'Korrozió ellenálló',
                    'Reteszelő összeköttetésekhez',
                    'Függesztett/függőleges, alátámasztás nélkül',
                ],
                'it-IT': [
                    'Oscillanti        Per corse brevi o lunghe        Minimo ingombro        Resistente alla corrosione        Quando serve un attacco fisso        Sospeso/verticale senza supporto',
                ],
                'ja-JP': [
                    '旋回型',
                    '短い、あるいは長いストロークに',
                    '取付け空間が狭い場合に',
                    '耐食性',
                    '固定型の接続に',
                    'サポートのない「吊り下げ型」「竪スタンド型」に',
                ],
                'ko-KR': [
                    '회전식',
                    '짧은 이동거리 및 긴 이동거리용',
                    '조립 부위가 협소할 경우',
                    '내식성',
                    '잠금식 연결용',
                    '지지없이 매달려 있거나 수직으로 세워져 있음',
                ],
                'nl-NL': [
                    'scharnierend',
                    'Voor korte en lange rijwegen',
                    'Voor nauwe montagedimensies',
                    'Corrosiebestendig',
                    'Voor borgende aansluitingen',
                    'Vrijdragend/verticaal zonder ondersteuning',
                ],
                'pl-PL': [
                    'wahliwe',
                    'Do krótkich i długich przesuwów',
                    'Przy ograniczonych przestrzeniach montażowych',
                    'Odporny na korozję',
                    'Połączenia samohamowne',
                    'Zastosowania wiszące lub stojące, bez podparcia',
                ],
                'pt-PT': [
                    'oscilante        Para cursos pequenos e longos        Para locais com pouco espaço        Resistente à corrosão        Para ligações rígidas        Suspensa / vertical sem suporte',
                ],
                'sv-SE': [
                    'pendlad / pendlat',
                    'För korta och långa förflyttningsvägar',
                    'För trånga installationsförhållanden',
                    'Korrosionsbeständigt',
                    'För fasta förbindelser',
                    'Hängande/stående utan stöd',
                ],
                'zh-TW': ['活動式      用於短和長行程      用於狹小空間      耐腐蝕      用於鎖定連接件      無支持懸浮/垂直'],
                'en-US': ['Short and long travels        Space-restricted conditions        Corrosion resistant'],
            },
            DataSource: 'ipro',
            IsStahl: false,
            HasCProfil: false,
            IsKMA: false,
            Ausfuehrung: 'kunststoff_pendelnd',
            HasKamm: true,
            Festpunkt: false,
            Mitnehmer: false,
            Komplettsatz: true,
            GliedAnzahlAbhaengig: 0,
            schemaVersion: '8',
            Application: 0,
            ArtNrGenerated: '2605.34PZB.A2',
            ArtNrExists: true,
        },
    ],
    AverageEnvironmentTemperatur: {
        Unit: '°C',
        Value: 20,
    },
    DomainVersion: '81.63.2',
    FileRefs: [],
    Fuehrungsrinnen: [],
    IAs: [
        {
            ArticleType: 'ia',
            EntityId: '5888339b-896d-4dad-9fcc-74cba1d17413',
            IABodenH: {
                Value: 0,
                Unit: 'mm',
            },
            IAHKB: {
                Value: 3,
                Unit: 'mm',
            },
            IAHKBOT: {
                Value: 0,
                Unit: 'mm',
            },
            IAHKDist: {
                Value: 0,
                Unit: 'mm',
            },
            IAHKH: {
                Value: 35,
                Unit: 'mm',
            },
            IAHKHeight: {
                Value: 0,
                Unit: 'mm',
            },
            IAHKOLB: {
                Value: 10.5,
                Unit: 'mm',
            },
            IAHKOLOB: {
                Value: 0,
                Unit: 'mm',
            },
            IAHKOLOH: {
                Value: 4.2,
                Unit: 'mm',
            },
            IAHKOLUB: {
                Value: 10.5,
                Unit: 'mm',
            },
            IAHKOLUH: {
                Value: 2.2,
                Unit: 'mm',
            },
            IAHKOLUH_Rounded: false,
            IAHKORB: {
                Value: 10.5,
                Unit: 'mm',
            },
            IAHKOROB: {
                Value: 0,
                Unit: 'mm',
            },
            IAHKORUB: {
                Value: 10.5,
                Unit: 'mm',
            },
            IAHKRep: 0,
            IAHKULB: {
                Value: 10.5,
                Unit: 'mm',
            },
            IAHKULOB: {
                Value: 10.5,
                Unit: 'mm',
            },
            IAHKULOH: {
                Value: 2.2,
                Unit: 'mm',
            },
            IAHKULOH_Rounded: false,
            IAHKULUB: {
                Value: 0,
                Unit: 'mm',
            },
            IAHKULUH: {
                Value: 4.2,
                Unit: 'mm',
            },
            IAHKURB: {
                Value: 10.5,
                Unit: 'mm',
            },
            IAHKUROB: {
                Value: 10.5,
                Unit: 'mm',
            },
            IAHKURUB: {
                Value: 0,
                Unit: 'mm',
            },
            IAKisteHO: {
                Value: 0,
                Unit: 'mm',
            },
            IAKisteHU: {
                Value: 0,
                Unit: 'mm',
            },
            IAUebermass: {
                Value: 0,
                Unit: 'mm',
            },
            IAwmm: {
                Value: 0,
                Unit: 'mm',
            },
            Artikeltyp: 2100,
            Fussbreite: {
                Value: 24,
                Unit: 'mm',
            },
            Kind: 'Trennsteg',
            BestTyp: 300,
            Gewicht: {
                Value: 0.0057100000381,
                Unit: 'kg',
            },
            ArtNr: {
                DE: '261.24',
                US: '261-24',
            },
            Bezeichnung: {
                'de-DE': 'Trennsteg, montiert',
                'hu-HU': 'Elválasztó, szerelt',
                'en-US': 'Separator, assembled',
                'zh-TW': '分隔板，已裝配',
                'ko-KR': '세로분리대, 조립',
                'es-ES': 'Separador, montado',
                'zh-CN': '分隔片，已装配',
                'it-IT': 'Separatore, assemblato',
                'pl-PL': 'Separator, zmontowany',
                'pt-PT': 'Separador, montado',
                'nl-NL': 'Scheidingsschot, gemonteerd',
                'sv-SE': 'Avdelare, monterad',
                'da-DK': 'Separator, monteret',
                'fr-FR': 'Séparateur, monté',
                'cs-CZ': 'Dělicí příčka, sestavená',
                'en-GB': 'Separator, assembled',
                'ja-JP': 'セパレーター、組付納入',
            },
            Montiert: true,
            KetteSerieRef: [
                {
                    Artikeltyp: 2100,
                    Kuerzel: '27',
                    Id: 3170,
                    CadLink: true,
                },
                {
                    Artikeltyp: 2100,
                    Kuerzel: '27i',
                    Id: 3297,
                    CadLink: true,
                },
                {
                    Artikeltyp: 2100,
                    Kuerzel: '2600',
                    Id: 4436,
                    CadLink: true,
                },
                {
                    Artikeltyp: 2100,
                    Kuerzel: '2700',
                    Id: 4664,
                    CadLink: true,
                },
            ],
            IARef: [
                {
                    Montiert: true,
                    Id: 3229,
                },
                {
                    Montiert: false,
                    Id: 3228,
                },
            ],
            KetteRef: [],
            Id: 3229,
            schemaVersion: '11',
            ArtNrExists: true,
            ArtNrGenerated: '261.24',
            IAIndex: '1',
            LocalTransform: [1, 0, 0, 1, 2.289999999999999, 0],
            StartingAtNthKettenglied: 1,
            PerNthKettenglied: 2,
        },
    ],
    IaArrangement: 'single',
    IsAlienConfiguration: false,
    IsIgnoreSafetyDistance: false,
    IsStackingOfLeitungenAllowed: false,
    IgusGUIds: [
        {
            id: 'COEKE0000159366',
            dirty: true,
            expired: true,
            exposed: true,
            creationTimestamp: 1663827887292,
        },
        {
            id: 'COEKE0000159367',
            dirty: true,
            expired: true,
            exposed: true,
            creationTimestamp: 1663827909293,
        },
        {
            id: 'COEKE0000159495',
            dirty: false,
            expired: false,
            exposed: true,
            creationTimestamp: 1663850552876,
        },
    ],
    Konfektionierungen: [],
    Kette: {
        ArticleType: 'kette',
        KetteSerieType: 'rolEchain',
        EntityId: 'b75ce423-bae1-4fe0-8089-f275a37fa4e3',
        RinneRef: [63550, 63558, 52396, 52397, 54946, 54947, 3107, 3108, 3094, 37650, 81586, 81741],
        MontagesetRef: [63569, 63570, 54948, 3099, 7704, 2534, 3109, 2538, 7719],
        RinnenvarianteRef: [],
        BelastungFLG: [],
        BelastungFLB: [],
        LangerWeg: true,
        Einspeisung: 1,
        Versatz: {
            Value: 0,
            Unit: 'mm',
        },
        MinBauraumGleitendRinneRefs: [
            {
                FuehrungsrinneId: 3094,
                FuehrungsrinneTyp: 'SuperAlu',
                FuehrungsrinneStuecklaenge: {
                    Unit: 'mm',
                    Value: 2000,
                },
                MontageSetId: 2534,
                Breite: {
                    Unit: 'mm',
                    Value: 159,
                },
                Hoehe: {
                    Unit: 'mm',
                    Value: 365,
                },
            },
            {
                FuehrungsrinneId: 3094,
                FuehrungsrinneTyp: 'SuperAlu',
                FuehrungsrinneStuecklaenge: {
                    Unit: 'mm',
                    Value: 2000,
                },
                MontageSetId: 7704,
                Breite: {
                    Unit: 'mm',
                    Value: 165,
                },
                Hoehe: {
                    Unit: 'mm',
                    Value: 365,
                },
            },
            {
                FuehrungsrinneId: 3107,
                FuehrungsrinneTyp: 'Stahl',
                FuehrungsrinneStuecklaenge: {
                    Unit: 'mm',
                    Value: 2000,
                },
                MontageSetId: 3109,
                Breite: {
                    Unit: 'mm',
                    Value: 184,
                },
                Hoehe: {
                    Unit: 'mm',
                    Value: 355,
                },
            },
        ],
        MinDistKlemmO: {
            Value: 0,
            Unit: 'mm',
        },
        MinDistKlemmU: {
            Value: 0,
            Unit: 'mm',
        },
        MinDistO: {
            Value: 0,
            Unit: 'mm',
        },
        MinDistU: {
            Value: 0,
            Unit: 'mm',
        },
        RastPosDist: {
            Value: 0,
            Unit: 'mm',
        },
        RastPosLeft: {
            Value: 0,
            Unit: 'mm',
        },
        StaticIAArtikelRef: [],
        IsMontageMitnehmer: false,
        ArtNr: {
            DE: 'ROLECHAIN__2700R.05.125.S10.0.E',
        },
        ArticleSpecs: ['rolEchain'],
        Bauform: 'Kette',
        BestTyp: 400,
        Bezeichnung: {
            'de-DE': 'igus® Rollenkettenglied 2700R',
            'en-GB': 'roll E-Chain link Series 2700R',
            'it-IT': 'roll maglia catena serie 2700R',
            'nl-NL': 'igus® Rollenkettenglied 2700R',
            'pt-BR': 'Calha articulada igus série 2700R',
            'pt-PT': 'Calha articulada igus série 2700R',
        },
        Biegeradius: {
            Value: 125,
            Unit: 'mm',
        },
        D1: {
            Value: 150,
            Unit: 'mm',
        },
        DataSource: 'stub',
        FreigabeEKE: true,
        GleitenderBetriebErlaubt: true,
        Halbstegig: false,
        FreigabeEIC: false,
        FreigabeEKEManualMode: false,
        IndexBiegeradius: '125',
        IndexBreite: '05',
        K2: {
            Value: 952,
            Unit: 'mm',
        },
        LangerWegZeichnungsnummer: '54730',
        NumFirstOtherLinks: 2,
        RolLinkRef: '2700R.05.125.S10.0.E',
        SerieRef: {
            Id: 9124617890,
            Kuerzel: '2700R',
        },
        SerienKurzbezeichnung: 'Serie_2700R',
        StandardLinkRef: '2700.05.125.0',
        UngeradeAnzahlGlieder: false,
        VersatzFestpunktErlaubt: true,
        X1: {
            Value: 450,
            Unit: 'mm',
        },
        BelastungGleitend: [
            {
                FZ: {
                    Value: 2.5,
                    Unit: 'kg_m',
                },
            },
            {
                FZ: {
                    Value: 1.25,
                    Unit: 'kg_m',
                },
            },
            {
                FZ: {
                    Value: 0.8250000000000001,
                    Unit: 'kg_m',
                },
            },
            {
                FZ: {
                    Value: 0.625,
                    Unit: 'kg_m',
                },
            },
            {
                FZ: {
                    Value: 0.25,
                    Unit: 'kg_m',
                },
            },
        ],
        BeschleunigungGleitendMax: {
            Value: 50,
            Unit: 'm_s2',
        },
        FZGleitendMax: {
            Value: 2.5,
            Unit: 'kg_m',
        },
        GeschwindigkeitGleitendMax: {
            Value: 10,
            Unit: 'm_s',
        },
        H: {
            Value: 300,
            Unit: 'mm',
        },
        HoeheVorspannung: {
            Value: 35,
            Unit: 'mm',
        },
        MaxAELaenge: {
            Value: 176,
            Unit: 'mm',
        },
        StandardTrennstegArtNr: '35.1.1',
        Id: 9034203618,
        Aussenbreite: {
            Value: 66,
            Unit: 'mm',
        },
        Aussenhoehe: {
            Value: 50,
            Unit: 'mm',
        },
        Innenbreite: {
            Value: 43.4,
            Unit: 'mm',
        },
        Innenhoehe: {
            Value: 35,
            Unit: 'mm',
        },
        LeitungDiameterMax: {
            Value: 32,
            Unit: 'mm',
        },
        TemperaturMin: {
            Value: -40,
            Unit: '°C',
        },
        TemperaturMax: {
            Value: 120,
            Unit: '°C',
        },
        ApproxGewichtKgProM: [
            [10, 1.1735981308411214],
            [50, 1.173696120689655],
            [100, 1.1736538461538462],
        ],
        ApproxVerfahrwegToEffektiveLaenge: [
            [10, 5.992],
            [20, 10.976],
            [30, 15.96],
            [50, 25.984],
            [75, 38.472],
            [100, 50.96],
        ],
        GewichtKgProM: {
            Value: 1.1735546875,
            Unit: 'kg_m',
        },
        PushPullForceMax: {
            Value: 600,
            Unit: 'N',
        },
        schemaVersion: '18',
        StandardLink: {
            Id: 4669,
            IproProduktgruppenId: 25,
            IproProduktId: 11,
            ArtNr: {
                DE: '2700.05.125.0',
                US: '2700-05-125-0',
            },
            BestTyp: 400,
            Bezeichnung: {
                'de-DE': 'e-kette® Serie 2700',
                'en-GB': 'e-chain® series 2700',
                'it-IT': 'Catena portacavi serie 2700',
                'pt-PT': 'Calhas articuladas da Série 2700',
                'es-ES': 'Cadena portacables serie 2700',
                'ja-JP': 'エナジーチェーン 2700型',
                'pl-PL': 'e-prowadniki serii 2700',
                'zh-CN': '2700系列拖链',
                'sv-SE': 'E-kedja serie 2700',
                'hu-HU': 'E-Chains® 2700 Széria',
                'da-DK': 'E-Kæde -serie 2700',
                'ko-KR': 'E-Chain® 2700 시리즈',
                'cs-CZ': 'e-chain® série 2700',
                'en-US': 'Energy chain® Series 2700',
                'nl-NL': 'Kabelrups serie 2700',
                'zh-TW': '2700系列拖鏈',
                'fr-FR': 'Chaîne Série 2700',
            },
            IndexBreite: '05',
            IndexBiegeradius: '125',
            ArtSerieBreite: '2700.05',
            GleitenderBetriebErlaubt: true,
            FreitragenderBetriebErlaubt: true,
            UngeradeAnzahlGlieder: false,
            VersatzFestpunktErlaubt: true,
            Teilung: {
                Value: 56,
                Unit: 'mm',
            },
            Aussenhoehe: {
                Value: 50,
                Unit: 'mm',
            },
            Innenhoehe: {
                Value: 35,
                Unit: 'mm',
            },
            D: {
                Value: 234,
                Unit: 'mm',
            },
            H: {
                Value: 300,
                Unit: 'mm',
            },
            Biegeradius: {
                Value: 125,
                Unit: 'mm',
            },
            Aussenbreite: {
                Value: 66,
                Unit: 'mm',
            },
            Innenbreite: {
                Value: 50,
                Unit: 'mm',
            },
            K: {
                Value: 505,
                Unit: 'mm',
            },
            K2: {
                Value: 784,
                Unit: 'mm',
            },
            GewichtKgProM: {
                Value: 1.17,
                Unit: 'kg_m',
            },
            LeitungDiameterMax: {
                Value: 32,
                Unit: 'mm',
            },
            SerieRef: {
                Id: 4664,
                Kuerzel: '2700',
            },
            RinneRef: [63550, 63558, 52396, 52397, 54946, 54947, 3107, 3108, 3094, 37650, 81586, 81741],
            MontagesetRef: [63569, 63570, 54948, 3099, 7704, 2534, 3109, 2538, 7719],
            FreigabeEIC: true,
            FreigabeEKEManualMode: true,
            RastPosDist: {
                Value: 2.5,
                Unit: 'mm',
            },
            RastPosLeft: {
                Value: 1,
                Unit: 'mm',
            },
            NoSeparaterFootBottom: true,
            StandardTrennstegArtNr: '35.1.1',
            Halbstegig: false,
            Bauform: 'Kette',
            SerienKurzbezeichnung: 'Serie_2700',
            BeschleunigungFLGMax: {
                Value: 200,
                Unit: 'm_s2',
            },
            GeschwindigkeitFLGMax: {
                Value: 20,
                Unit: 'm_s',
            },
            BeschleunigungFLBMax: {
                Value: 6,
                Unit: 'm_s2',
            },
            GeschwindigkeitFLBMax: {
                Value: 3,
                Unit: 'm_s',
            },
            BeschleunigungGleitendMax: {
                Value: 50,
                Unit: 'm_s2',
            },
            GeschwindigkeitGleitendMax: {
                Value: 10,
                Unit: 'm_s',
            },
            EinbauartLangeVerfahrwege: {
                Value: 120,
                Unit: 'm',
            },
            EinbauartHaengendMax: {
                Value: 50,
                Unit: 'm',
            },
            TemperaturMax: {
                Value: 120,
                Unit: '°C',
            },
            TemperaturMin: {
                Value: -40,
                Unit: '°C',
            },
            ArticleType: 'link',
            FreigabeEKE: true,
            WeightPerLink: {
                Unit: 'g',
                Value: 65.52,
            },
            DataSource: 'ipro',
            KetteSerieType: 'default',
            StaticIAArtikelRef: [],
            BelastungFLG: [
                {
                    FZ: {
                        Value: 8,
                        Unit: 'kg_m',
                    },
                    FL: {
                        Value: 0,
                        Unit: 'm',
                    },
                },
                {
                    FZ: {
                        Value: 8,
                        Unit: 'kg_m',
                    },
                    FL: {
                        Value: 1.1,
                        Unit: 'm',
                    },
                },
                {
                    FZ: {
                        Value: 2,
                        Unit: 'kg_m',
                    },
                    FL: {
                        Value: 1.9,
                        Unit: 'm',
                    },
                },
                {
                    FZ: {
                        Value: 0,
                        Unit: 'kg_m',
                    },
                    FL: {
                        Value: 2.5,
                        Unit: 'm',
                    },
                },
            ],
            BelastungFLB: [
                {
                    FZ: {
                        Value: 8,
                        Unit: 'kg_m',
                    },
                    FL: {
                        Value: 0,
                        Unit: 'm',
                    },
                },
                {
                    FZ: {
                        Value: 8,
                        Unit: 'kg_m',
                    },
                    FL: {
                        Value: 1.3,
                        Unit: 'm',
                    },
                },
                {
                    FZ: {
                        Value: 2,
                        Unit: 'kg_m',
                    },
                    FL: {
                        Value: 2.05,
                        Unit: 'm',
                    },
                },
                {
                    FZ: {
                        Value: 0,
                        Unit: 'kg_m',
                    },
                    FL: {
                        Value: 2.7,
                        Unit: 'm',
                    },
                },
            ],
            HoeheVorspannung: {
                Value: 35,
                Unit: 'mm',
            },
            PushPullForceMax: {
                Value: 600,
                Unit: 'N',
            },
            FZGleitendMax: {
                Value: 2.5,
                Unit: 'kg_m',
            },
            MaxAELaenge: {
                Value: 176,
                Unit: 'mm',
            },
            BelastungGleitend: [
                {
                    FZ: {
                        Value: 2.5,
                        Unit: 'kg_m',
                    },
                },
                {
                    FZ: {
                        Value: 1.25,
                        Unit: 'kg_m',
                    },
                },
                {
                    FZ: {
                        Value: 0.8250000000000001,
                        Unit: 'kg_m',
                    },
                },
                {
                    FZ: {
                        Value: 0.625,
                        Unit: 'kg_m',
                    },
                },
                {
                    FZ: {
                        Value: 0.25,
                        Unit: 'kg_m',
                    },
                },
            ],
            BeschleunigungHaengendMax: {
                Value: 25,
                Unit: 'm_s2',
            },
            GeschwindigkeitHaengendMax: {
                Value: 10,
                Unit: 'm_s',
            },
            MinBauraumGleitendRinneRefs: [
                {
                    FuehrungsrinneId: 3094,
                    FuehrungsrinneTyp: 'SuperAlu',
                    FuehrungsrinneStuecklaenge: {
                        Unit: 'mm',
                        Value: 2000,
                    },
                    MontageSetId: 2534,
                    Breite: {
                        Unit: 'mm',
                        Value: 159,
                    },
                    Hoehe: {
                        Unit: 'mm',
                        Value: 365,
                    },
                },
                {
                    FuehrungsrinneId: 3094,
                    FuehrungsrinneTyp: 'SuperAlu',
                    FuehrungsrinneStuecklaenge: {
                        Unit: 'mm',
                        Value: 2000,
                    },
                    MontageSetId: 7704,
                    Breite: {
                        Unit: 'mm',
                        Value: 165,
                    },
                    Hoehe: {
                        Unit: 'mm',
                        Value: 365,
                    },
                },
                {
                    FuehrungsrinneId: 3107,
                    FuehrungsrinneTyp: 'Stahl',
                    FuehrungsrinneStuecklaenge: {
                        Unit: 'mm',
                        Value: 2000,
                    },
                    MontageSetId: 3109,
                    Breite: {
                        Unit: 'mm',
                        Value: 184,
                    },
                    Hoehe: {
                        Unit: 'mm',
                        Value: 355,
                    },
                },
            ],
            EchainSystem: 'E2000_medium',
            RinnenvarianteRef: [
                {
                    Name: 'FRV Führungsrinne "Super-Alu", "Basic"',
                    RinneRef: [3094, 37650],
                    MontagesetRef: [2533, 2534, 2535, 2536, 2537, 2538, 69650],
                },
                {
                    Name: 'FRV Führungsrinne "Super-Alu", "Heavy Duty"',
                    RinneRef: [3094, 37650],
                    MontagesetRef: [7704, 7705, 7706, 7707, 7708, 7709, 7719, 69650],
                },
                {
                    Name: 'FRV Führungsrinnen aus Stahl',
                    RinneRef: [3107, 3108, 81586, 81741],
                    MontagesetRef: [3109, 3110, 3111, 3112],
                },
                {
                    Name: 'ARNV Ablegerinne Typ 01',
                    RinneRef: [
                        52396, 52397, 54946, 54947, 54949, 54950, 54951, 54952, 54956, 54957, 54958, 54959, 54960, 54961, 54962,
                        54963,
                    ],
                    MontagesetRef: [54948, 54953, 54954, 54955],
                },
                {
                    Name: 'FRV Führungsrinne "guidefast"',
                    RinneRef: [
                        63545, 63546, 63547, 63548, 63549, 63550, 63551, 63552, 63553, 63554, 63555, 63556, 63557, 63558, 63559,
                        63560,
                    ],
                    MontagesetRef: [63569, 63570],
                },
            ],
            LangerWegZeichnungsnummer: '24693',
            X1: {
                Value: 360,
                Unit: 'mm',
            },
            D1: {
                Value: 150,
                Unit: 'mm',
            },
            WidenBildId: 'b4b56950-9875-4cf5-8429-db26462d63d2',
            WidenZeichnungId: {
                'cs-CZ': '637c7026-043c-4159-8e04-74b41f6e8e89',
                'zh-CN': '637c7026-043c-4159-8e04-74b41f6e8e89',
                'en-US': '39dbd9aa-f44b-4b9a-864c-dda5a76c97ef',
                'de-DE': '637c7026-043c-4159-8e04-74b41f6e8e89',
                'sv-SE': '637c7026-043c-4159-8e04-74b41f6e8e89',
                'en-GB': '637c7026-043c-4159-8e04-74b41f6e8e89',
                'it-IT': '637c7026-043c-4159-8e04-74b41f6e8e89',
                'da-DK': '637c7026-043c-4159-8e04-74b41f6e8e89',
                'hu-HU': '637c7026-043c-4159-8e04-74b41f6e8e89',
                'ja-JP': '637c7026-043c-4159-8e04-74b41f6e8e89',
                'fr-FR': '637c7026-043c-4159-8e04-74b41f6e8e89',
                'ko-KR': '637c7026-043c-4159-8e04-74b41f6e8e89',
                'zh-TW': '637c7026-043c-4159-8e04-74b41f6e8e89',
                'pl-PL': '637c7026-043c-4159-8e04-74b41f6e8e89',
                'pt-PT': '637c7026-043c-4159-8e04-74b41f6e8e89',
                'es-ES': '637c7026-043c-4159-8e04-74b41f6e8e89',
            },
            schemaVersion: '18',
            ArtNrGenerated: '2700.05.125.0',
            ArtNrExists: true,
        },
        RolLink: {
            ArticleType: 'link',
            ArtNr: {
                DE: '2700R.05.125.S10.0.E',
            },
            Id: 9219770143,
            DataSource: 'stub',
            ArticleSpecs: ['rolEchainRolLink'],
            Bezeichnung: {
                'de-DE': 'igus® Rollenkettenglied 2700R',
                'en-GB': 'roll E-Chain link Series 2700R',
                'it-IT': 'roll maglia catena serie 2700R',
                'nl-NL': 'igus® Rollenkettenglied 2700R',
                'pt-BR': 'Calha articulada igus série 2700R',
                'pt-PT': 'Calha articulada igus série 2700R',
            },
            LangerWegZeichnungsnummer: '54730',
            BestTyp: 400,
            SerieRef: {
                Id: 9124617890,
                Kuerzel: '2700R',
            },
            Teilung: {
                Value: 112,
                Unit: 'mm',
            },
            Innenbreite: {
                Value: 43.4,
                Unit: 'mm',
            },
            Aussenbreite: {
                Value: 66,
                Unit: 'mm',
            },
            Biegeradius: {
                Value: 125,
                Unit: 'mm',
            },
            Innenhoehe: {
                Value: 35,
                Unit: 'mm',
            },
            Aussenhoehe: {
                Value: 50,
                Unit: 'mm',
            },
            K2: {
                Value: 952,
                Unit: 'mm',
            },
            BelastungGleitend: [
                {
                    FZ: {
                        Value: 2.5,
                        Unit: 'kg_m',
                    },
                },
            ],
            FZGleitendMax: {
                Value: 2.5,
                Unit: 'kg_m',
            },
            SerienKurzbezeichnung: 'Serie_2700R',
            IndexBreite: '05',
            IndexBiegeradius: '125',
            NumFirstOtherLinks: 2,
            Bauform: 'Kette',
            Halbstegig: false,
            VersatzFestpunktErlaubt: true,
            UngeradeAnzahlGlieder: false,
            GleitenderBetriebErlaubt: true,
            FreigabeEIC: false,
            FreigabeEKEManualMode: false,
            FreigabeEKE: true,
            KetteSerieType: 'rolEchain',
            X1: {
                Value: 450,
                Unit: 'mm',
            },
            D1: {
                Value: 150,
                Unit: 'mm',
            },
            WeightPerLink: {
                Value: 133,
                Unit: 'g',
            },
            PushPullForceMax: {
                Value: 600,
                Unit: 'N',
            },
            schemaVersion: '18',
            ArtNrGenerated: '2700R.05.125.S10.0.E',
            ArtNrExists: true,
        },
        Serie: {
            KetteSerieType: 'rolEchain',
            DataSource: 'stub',
            Id: 9124617890,
            Kuerzel: '2700R',
            FreigabeEIC: false,
            FreigabeEKEManualMode: false,
            LangerWegZeichnungsnummer: '54730',
            RolEchainParts: [
                {
                    Name: 'Part1a',
                    NumKG: 13,
                    NumRKG: 1,
                    NumAKG: 0,
                },
                {
                    Name: 'Part1b',
                    NumKG: 2,
                    NumRKG: 1,
                    NumAKG: 0,
                },
                {
                    Name: 'Part1c',
                    NumKG: 2,
                    NumRKG: 1,
                    NumAKG: 0,
                },
                {
                    Name: 'Part1d',
                    NumKG: 0,
                    NumRKG: 0,
                    NumAKG: 0,
                },
                {
                    Name: 'Part1e',
                    NumKG: 0,
                    NumRKG: 0,
                    NumAKG: 0,
                },
                {
                    Name: 'Part2',
                    NumKG: 7,
                    NumRKG: 1,
                    NumAKG: 0,
                },
                {
                    Name: 'Part3',
                    NumKG: 8,
                    NumRKG: 1,
                    NumAKG: 0,
                },
            ],
            Grease: {
                ArtNr: {
                    DE: 'MAT0020004',
                    US: 'MAT0020004',
                },
                Description: {
                    'de-DE': 'Schmierfett',
                    'en-US': 'Lubricating grease',
                    'en-GB': 'Lubricating grease',
                },
            },
            schemaVersion: '8',
        },
        ArtNrGenerated: '2700R.05.125.S10.0.E',
        ArtNrExists: true,
        LengthCalcInitializedBy: 'verfahrweg',
        Verfahrweg: {
            Unit: 'mm',
            Value: 12345,
        },
        Laenge: {
            Value: 7168,
            Unit: 'mm',
        },
        NumGlieder: 115,
        EffektiveLaenge: {
            Unit: 'mm',
            Value: 7168,
        },
        EffektiveLaengeWithAEs: {
            Value: 7344,
            Unit: 'mm',
        },
    },
    Leitungen: [],
    LeitungBomBehavior: 'UseAll',
    MontBes: [],
    MontageSets: [],
    PdfRefs: [],
    QuoteCount: 1,
    UseSameIAColorAndMaterial: false,
    Verpackungen: [],
    Zugentlastungen: [],
    ManagedConfigurationType: 'Expert',
    Einbauart: 'gleitend',
    HasNoRinne: false,
    ConfigurationStartedWith: 'kette',
    Zusatzlast: {
        Unit: 'kg_km',
        Value: 5,
    },
    KetteFilterProperties: {
        versatz_mm: 0,
        verfahrweg_mm: 12345,
        langerWeg: true,
    },
    AllowedBauformen: ['Kette'],
    GeschwindigkeitMax: {
        Unit: 'm_s',
        Value: 1,
    },
    BeschleunigungMax: {
        Unit: 'm_s2',
        Value: 1,
    },
    HasNoAE: false,
    IAZeichnungsnummer: 'COEKE0000159495',
    IACompanyName: 'n/a',
    IAAuthorName: 'gh',
    IgusGUId: 'COEKE0000159495',
    LeitungFilterProperties: {
        category: 'BusCables',
        busSystem: 'ASI BUS (Flachleitungen)',
    },
};
//# sourceMappingURL=rolEchainConfigurationMocks.js.map